import environment from "@/environment/aisea";
import Vue from "vue";

class GtagService {

  /**
   * コンバージョンアクション: AiseaCrew - 仮登録
   */
  crewProvisionalRegistration() {
    if (environment.isProduction()) {
      // eslint-disable-next-line no-undef
      gtag('event', 'conversion', {'send_to': 'AW-10991731316/sa4CCKnG0eYDEPSEovko'});
      Vue.$log.debug("[gtag]", "conversion send_to:AW-10991731316/sa4CCKnG0eYDEPSEovko");
    }
  }

  /**
   * コンバージョンアクション: AiseaCrew - 本登録
   */
  crewDefinitiveRegistration() {
    if (environment.isProduction()) {
      // eslint-disable-next-line no-undef
      gtag('event', 'conversion', {'send_to': 'AW-10991731316/_wt8CJra1eYDEPSEovko'})
      Vue.$log.debug("[gtag]", "conversion send_to:AW-10991731316/_wt8CJra1eYDEPSEovko");
    }
  }

}

export default new GtagService();
